module.exports = __webpack_public_path__ + "static/img/logo_hh.ba91f63.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/logo_hh.png
// module id = 981
// module chunks = 1